import React from "react";
import { CollageTemplateType } from "../../utils/constants";

interface TemplateSelectorProps {
  selectedTemplate: CollageTemplateType;
  onSelect: (template: CollageTemplateType) => void;
}

type TemplateDef = {
  id: CollageTemplateType;
  label: string;
  cols: number;
  rows: number;
  cells: number;
};

const templates: TemplateDef[] = [
  { id: "grid1x1", label: "1×1 Grid", cols: 1, rows: 1, cells: 1 },
  { id: "grid1x2", label: "1×2 Grid", cols: 1, rows: 2, cells: 2 },
  { id: "grid2x1", label: "2×1 Grid", cols: 2, rows: 1, cells: 2 },
  { id: "grid2x2", label: "2×2 Grid", cols: 2, rows: 2, cells: 4 },
  { id: "grid3x1", label: "3 Horizontal", cols: 3, rows: 1, cells: 3 },
  { id: "grid3x2", label: "3×2 Grid", cols: 3, rows: 2, cells: 6 },
  { id: "grid3x3", label: "3×3 Grid", cols: 3, rows: 3, cells: 9 },
  { id: "auto", label: "Auto Layout", cols: 3, rows: 2, cells: 5 },
];

// Thumbnail Component
const Thumbnail: React.FC<{
  cols: number;
  rows: number;
  label: string;
  active?: boolean;
}> = ({ cols, rows, label, active }) => {
  const cells = Array.from({ length: cols * rows });

  return (
    <div
      className={`p-2 rounded-xl border transition-all duration-200 select-none ${
        active
          ? "border-blue-500 shadow-lg shadow-blue-100 scale-[1.03]"
          : "border-gray-200 hover:border-blue-300 hover:shadow-md"
      } bg-white cursor-pointer`}
    >
      <div
        className="grid w-full h-20 overflow-hidden rounded-md"
        style={{
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridTemplateRows: `repeat(${rows}, 1fr)`,
          gap: "3px",
        }}
      >
        {cells.map((_, i) => (
          <div
            key={i}
            className="bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] text-gray-400"
          />
        ))}
      </div>
      <div className="text-xs text-center mt-2 text-gray-700 truncate">{label}</div>
    </div>
  );
};

const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  selectedTemplate,
  onSelect,
}) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
        {templates.map((t) => (
          <button
            key={t.id}
            onClick={() => onSelect(t.id)}
            className="focus:outline-none w-full"
            aria-pressed={selectedTemplate === t.id}
          >
            <Thumbnail
              cols={t.cols}
              rows={t.rows}
              label={t.label}
              active={selectedTemplate === t.id}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;
